import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/parts-catalog-test")({
  beforeLoad: () => {
    throw redirect({ to: "/parts-preview", statusCode: 301 });
  },
});
